import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { Container } from '@lumahealthhq/ui-core';

/**
 * This is the Fallback component consumers will use to wrap the module with the `ModuleWrapper`.
 *
 * @example
 * <ModuleWrapper fallback={<FallbackContainerAuthPatientLogin />} ...>
 *   <ContainerAuthPatientLogin ... />
 * </ModuleWrapper>
 */
import { jsx as _jsx } from "react/jsx-runtime";
export default function FallbackContainerAuthPatientLogin(props) {
  return /*#__PURE__*/_jsx(Container, _extends({}, props));
}